/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import cx from 'classnames';
import { node, string, bool } from 'prop-types';
import React from 'react';

import './Bar.scss';

export const Bar = ({
  children,
  className,
  color,
  innerPadding,
  outerPadding,
  role
}) => (
  <div
    className={cx('Bar', {
      'Bar--no-padding': outerPadding === false,
      [`Bar--${color}`]: color,
      [`Bar--${role}`]: role,
      [`${className}`]: className
    })}>
    <div
      className={cx('Section', {
        'Section--no-padding': innerPadding === false
      })}>
      {children}
    </div>
  </div>
);

Bar.defaultProps = {
  padding: true
};

Bar.propTypes = {
  children: node.isRequired,
  className: string,
  color: string,
  innerPadding: bool,
  outerPadding: bool,
  role: string
};

export default Bar;
